var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('div',{ref:"agriEcoDev",style:('height:' + (_vm.height - 60).toString() + 'px;' + 'width: 100%'),attrs:{"id":"largeExposureChart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }